import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/git-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M140.1 348.5C152.2 348.5 169.6 350.6 169.6 366.4 169.6 381.9 155.7 385.2 142.6 385.2 130.3 385.2 111.7 383.2 111.7 367.2S127.4 348.5 140.1 348.5zM115.4 231.9C115.4 246.7 122 256 137.7 256 153.2 256 158.9 246 158.9 231.5 159 197.1 115.4 196.7 115.4 231.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM207 173.7C194.7 178.5 181.5 182.1 168.1 182.1 129.6 160 77.4 183 77.4 231.6 77.4 249.6 89 274.5 107 280.5V281.2C93.6 287.1 89.9 317.3 107.7 328.2V328.9C88.2 335.3 75.4 347.7 75.4 369.1 75.4 405.9 110.2 416.1 140.8 416.1 177.9 416.1 205.6 402.7 205.6 361.8 205.6 311.4 133.5 330 133.5 302.7 133.5 293.1 138.7 289.3 147.6 287.5 177.2 282 195.8 258.9 195.8 228.8 195.8 223.6 194.7 218.6 192.9 213.8 197.7 212.7 202.4 211.5 207 209.9V173.7zM263.8 175.5H224.2C225.5 186.1 225.3 318.1 224.2 331H263.8C262.7 318.2 262.6 185.9 263.8 175.5zM268.3 122.2C268.3 108.8 258.3 96 244.2 96 229.9 96 219.6 108.5 219.6 122.2 219.6 135.8 230.1 148.1 244.2 148.1 257.9 148.1 268.3 135.6 268.3 122.2zM372.6 175.5H336.2C336.2 165.7 335.8 155.9 337.3 146H296.8C298.1 153.3 297.9 159.6 297.9 175.5H280.8V209.4C292.7 207.5 292.9 208.7 297.9 208.7V209.4H297.5V272.1C297.5 303.2 302 333.3 340.2 333.3 350.9 333.3 363.2 331.5 372.7 326.3V291.3C367 295.2 358.8 297.2 351.8 297.2 338.6 297.2 336.3 284.3 336.3 273.8V208.6C359 208.6 372.7 209.3 372.7 209.3V175.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/git-square.js
// module id = Z70E
// module chunks = 144